$(document).ready(function() {
    $('.gform_wrapper select').select2({
        minimumResultsForSearch: Infinity,
    });
});